export * from './default.service';
import { DefaultService } from './default.service';
export * from './sensor.service';
import { SensorService } from './sensor.service';
export * from './smartplug.service';
import { SmartplugService } from './smartplug.service';
export const APIS = [DefaultService, SensorService, SmartplugService];
